module.exports = __webpack_public_path__ + "img/pin.8d4e455e.svg";